import { useState } from 'react'
import {
  Grid,
  Typography,
  IconButton,
  Tooltip,
  Divider,
  Backdrop,
  CircularProgress,
  makeStyles,
  Button
} from '@material-ui/core'
import { useWindowSize } from '../../hooks/useWindowSize'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import AddIcon from '@material-ui/icons/Add'
import { toast } from 'react-toastify'
import { genBase64 } from '../../common/utils'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

const LoadMultipleFiles = (props) => {
  const size = useWindowSize()
  const classes = useStyles()

  const canDelete = props.canDelete ? props.canDelete : true
  const resources = props.resources
  const setResources = props.setResources
  const noDataLabel = props.noDataLabel ? props.noDataLabel : 'No hay documentos.'
  const titleLabel = props.titleLabel ? props.titleLabel : 'Adjuntos'
  const addButtonLabel = props.addButtonLabel ? props.addButtonLabel : 'Añadir'
  const validFileFormat = props.validFileFormat

  const [loading, setLoading] = useState(false)

  const handleDeleteFile = async (index) => {
    let newArray = resources
    await newArray.splice(index, 1)
    setResources([])
    await setResources(newArray)
  }

  const openFileExplorer = () => {
    document.getElementById('docto').click()
  }

  const handleAddDoctos = async () => {
    let input = document.getElementById('docto')
    if (input.files.length === 0) return
    setLoading(true)
    let newFile = []
    for (const file of input.files) {
      if (validFileFormat && !validFileFormat.split(', ').includes(file.type)) {
        toast.error(
          `El archivo ${file.name} no es valido. Solo se permiten archivos ${validFileFormat}`
        )
        continue
      }

      newFile.push({
        fileName: file.name,
        base64Content: await genBase64(file)
      })
    }
    const newFileList = resources.concat(newFile)
    setResources(newFileList)
    input.value = ''
    setLoading(false)
  }

  return (
    <div>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={8}>
          <Typography color="primary" variant="body1">
            {titleLabel}
          </Typography>
        </Grid>
        <Grid item xs={4} className="text-right mb-2">
          <Button color="secondary" variant="outlined" size="small" onClick={openFileExplorer}>
            <AddIcon /> {size.width > 540 ? addButtonLabel : ''}
          </Button>
        </Grid>
      </Grid>
      <Divider className="mb-3" />
      {resources !== undefined && resources.length > 0 ? (
        resources.map((resource, index) => (
          <Grid key={`item-resource-${index}`} container spacing={1} alignItems="center">
            <Grid item xs={canDelete ? 11 : 12}>
              {resource.fileName}
            </Grid>
            {canDelete && (
              <Grid item xs={1}>
                <Tooltip title={`Eliminar ${resource.fileName}`}>
                  <IconButton size="small" onClick={() => handleDeleteFile(index)}>
                    <DeleteOutlineOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        ))
      ) : (
        <Typography color="primary" className="text-left text-sm-center">
          {noDataLabel}
        </Typography>
      )}
      <Divider className="mt-3" />
      <input
        type="file"
        multiple
        accept={validFileFormat ? validFileFormat : ''}
        id="docto"
        name="docto"
        style={{ display: 'none' }}
        onChange={handleAddDoctos}
      />
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default LoadMultipleFiles
